const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const resolveStoragePriceValues = (source = {}) => {
  const baseAmount = toNumber(
    source.baseAmount ?? source.base_amount ?? source.storage_base_amount ?? source.storageBaseAmount
  );
  const finalAmount = toNumber(
    source.finalAmount ?? source.final_amount ?? source.storage_final_amount ?? source.storageFinalAmount
  );

  const resolvedBase = baseAmount > 0 ? baseAmount : finalAmount;
  const resolvedFinal = finalAmount > 0 ? finalAmount : resolvedBase;

  return {
    baseAmount: resolvedBase,
    finalAmount: resolvedFinal,
    effectiveAmount: resolvedFinal,
  };
};
